import { render, staticRenderFns } from "./userSegmentationAcrossDifferentChannels.vue?vue&type=template&id=1d4f43f0&scoped=true&"
import script from "./userSegmentationAcrossDifferentChannels.vue?vue&type=script&lang=js&"
export * from "./userSegmentationAcrossDifferentChannels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4f43f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d4f43f0')) {
      api.createRecord('1d4f43f0', component.options)
    } else {
      api.reload('1d4f43f0', component.options)
    }
    module.hot.accept("./userSegmentationAcrossDifferentChannels.vue?vue&type=template&id=1d4f43f0&scoped=true&", function () {
      api.rerender('1d4f43f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/userSegmentationAcrossDifferentChannels.vue"
export default component.exports